import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  filter(event) {
    const url = event.target.value
    if (url) {
      Turbo.visit(url)
    }
  }
}